export default function _identity(x) {
  return x;
}


//////////////////
// WEBPACK FOOTER
// ./~/ramda/es/internal/_identity.js
// module id = 351
// module chunks = 1